export const insurancePolicyNumber = /^[A-Za-z0-9-]+$/;
